export default "__VITE_ASSET__d4c2f0a6__"